import { useMemo } from 'react';

import { AdminFundsSortField, AdminViewsFund } from '@/api/admin/types';
import { SortDirectionType } from '@/api/types';
import { getTableMinWidth, Table } from '@/design-system';

import { buildTableRows, fundsTableColumns } from '../data';

type Props = {
  items: AdminViewsFund[];
  isLoading: boolean;
  sortBy: AdminFundsSortField;
  sortDirection: SortDirectionType | null;
  onSort: (_key: string) => void;
  visibleColumns: string[];
};

export const FundsListView = ({
  items,
  isLoading,
  sortBy,
  sortDirection,
  onSort,
  visibleColumns,
}: Props) => {
  const rows = useMemo(() => buildTableRows(items), [items]);

  const filteredColumns = useMemo(
    () => fundsTableColumns.filter((col) => visibleColumns.includes(col.key)),
    [visibleColumns],
  );

  return (
    <Table
      columns={filteredColumns}
      rows={rows}
      size="lg"
      sortKey={sortBy}
      sortDirection={sortDirection}
      onSort={onSort}
      isLoading={isLoading}
      minTableWidth={getTableMinWidth(filteredColumns)}
    />
  );
};
